import Link from "next/link";
import TermsOfServiceStyles from './TermsOfServiceStyles'
import CheckboxInline from '@/components/Inputs/CheckboxInline'


export default function TermsOfService({ id, text, buttonText }) {
  /**
   * Terms of Service proclamation with ability to opt
   * in or out of SMS capabilities. Used with Formik.
   * 
   * id: Mapped to an element in Formik's initialValues. Make sure it matches.
   * text: Customizes the default Terms of Service text.
   */

  return (
    <TermsOfServiceStyles>
      {text ? (
        <span dangerouslySetInnerHTML={{ __html: text }} />
      ) : (
        <span>
          By clicking "{buttonText}" you agree to our&nbsp;
          <Link href="/terms-of-services">
            <a target="_blank">Terms of Service</a>
          </Link>
          . This includes permission to communicate with you about your appointments
          via phone, email, or SMS. If you prefer to opt-out of SMS communications
          you may uncheck this box
        </span>
      )}
      &nbsp;
      <CheckboxInline id={id} />
    </TermsOfServiceStyles>
  )
}